import Html from "./Html";
import WordStyle, { WordInterlinearNumberStyle } from "./WordStyle";

export default class WordRenderer {

    constructor(private readonly style: WordStyle) {
    }

    public renderWord(word: string, index: number): string {
        if (word !== '') {
            const parts = this.style.partSeparator ? word.split(this.style.partSeparator) : [word];
            const transformedParts = parts.map(part => this.style.partTransformer ?
                this.style.partTransformer.transformText(part) : part);
            const partsWithAttributes = this.addPartAttributes(transformedParts, index);
            const reformedWord = partsWithAttributes.join(this.style.partJoiner ?
                this.style.partJoiner : this.style.partSeparator);
            word = this.addInterlinearNumber(reformedWord, index + 1);
        } else if (this.style.emptyText) {
            word = this.style.emptyText;
        }

        if (this.style.classes && this.style.classes.length > 0) {
            word = `<span class="${this.style.classes.join(' ')}">${word}</span>`;
        }
        return word;
    }

    private addPartAttributes(parts: string[], wordIndex: number): string[] {
        return parts.map((part, partIndex) => {
            const attributes = [];

            if (this.style.lexiconLookup) {
                attributes.push('class="_LexiconLookup"');
                attributes.push(`data-verse-index="${this.style.lexiconLookup.verseIndex}"`);
                attributes.push(`data-source-index="${this.style.lexiconLookup.sourceIndex}"`);
                attributes.push(`data-word-index="${wordIndex}"`);
                attributes.push(`data-part-index="${partIndex}"`);
            }

            if (this.style.tooltipGenerator) {
                // This relies on a ReactTooltip component to be rendered with an ID of VerseTextTooltip.
                const tooltip = this.style.tooltipGenerator.transformText(part);
                attributes.push(`data-tip="${tooltip}"`);
                attributes.push('data-for="VerseTextTooltip"');
            }

            part = Html.escapeText(part);
            if (attributes.length > 0) {
                part = `<span ${attributes.join(' ')}>${part}</span>`;
            }

            return part;
        });
    }

    private addInterlinearNumber(text: string, interlinearNumber: number): string {
        const classes = [];
        if (this.style.interlinearNumberStyle === WordInterlinearNumberStyle.AddStandardSequential) {
            classes.push('_InterlinearNumber');
        } else if (this.style.interlinearNumberStyle === WordInterlinearNumberStyle.AddAlternateSequential) {
            classes.push('_InterlinearNumber', '_AlternateInterlinearNumber');
        }
        if (classes.length > 0) {
            text += `<span class="${classes.join(' ')}">${interlinearNumber}</span>`;
        }
        return text;
    }
}
